import { MouseEvent, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { TrashIcon } from '../Icons';
import { Tooltip } from '../Tooltip';

type DeleteButtonProps = {
  disabled?: boolean;
  onClick: (event: MouseEvent) => void;
  tooltip?: ReactNode;
  className?: string;
};

export const DeleteButton = ({
  disabled,
  onClick,
  tooltip,
  className,
}: DeleteButtonProps) => {
  return (
    <Tooltip
      enabled={disabled && !!tooltip}
      content={tooltip}
      placement="top"
      showArrow
      containerClassName="h-full"
    >
      <button
        disabled={disabled}
        className={twMerge(
          'h-full text-gray-500 hover:text-gray-700',
          disabled && 'cursor-default opacity-50',
          className,
        )}
        onClick={(event) => {
          event.stopPropagation();
          onClick(event);
        }}
      >
        <TrashIcon />
      </button>
    </Tooltip>
  );
};
